import { ReactElement } from "react";
import { IconProps } from "./iconPropsTypes";

const CheckMark = ({
  fill = "currentColor",
  height = "1em",
  width = "1em"
}: IconProps): ReactElement => (
  <svg
    height={height}
    version="1.1"
    viewBox="0 0 16 11"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-181.000000, -1608.000000)">
      <polygon
        fill={fill}
        points="22.3356362 11.2525907 23.6643638 12.7474093 13.9596278 21.3738414 8.29289322 15.7071068 9.70710678 14.2928932 14.0403722 18.6261586"
        transform="translate(173.000000, 1597.000000)"
      ></polygon>
    </g>
    <title>check mark</title>
  </svg>
);

export default CheckMark;
